import http from "../http";

export const updateSectionContent = (sectionId, content) =>
  http.patch(`/store-management/sections/${sectionId}/`, {
    content_json: content,
  });

export const updateSectionItem = (itemId, content) =>
  http.patch(`/store-management/section-items/${itemId}/`, {
    content_json: content,
  });

export const createSectionItem = (sectionId, content = {}) =>
  http.post(`/store-management/section-items/`, {
    section_id: sectionId,
    content_json: content,
  });

export const deleteSectionItem = (itemId) =>
  http.delete(`/store-management/section-items/${itemId}/`);
